import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { WidgetType } from "../Enums/WidgetType";
import { ElementHelper } from "../Helpers/ElementHelper";
import { MultipleFilterModel } from "../Models/MultipleFilterModel";
import { FiltersManager } from "./FiltersManager";

export class UpdateListManager {

    constructor(private containerElement: JQuery) {
    }

    private updateListId;

    public filtersManager : FiltersManager;

    public initialize() {

        let self = this;

        this.filtersManager = new FiltersManager(this.containerElement.find('.filter-container'), WidgetType.UpdateWidget);
        this.filtersManager.initialize();

        this.filtersManager.onFiltersChange.subscribe((sender, result) => {
            self.loadUpdates(result.searchString, result.simpleFilters, result.multipleFilters);
        })

        $('#search-updates-form').each((index, element) => {
            var searchForm = $(element);
            searchForm.on('submit', () => {
                this.loadUpdates(searchForm.find('#search').val()?.toString() ?? "", undefined, undefined)
            })
        })

        self.updateListId = self.containerElement.data('update-list-id');
        
        var initialFilters = this.filtersManager.getFilters();
        self.loadUpdates(initialFilters.searchString, initialFilters.simpleFilters, initialFilters.multipleFilters);
    }

    loadUpdates(search: string, simpleFilters : string[] | undefined, multipleFilters : MultipleFilterModel[] | undefined) {

        let self = this;

        var updateListItems = this.containerElement.find('[data-update-list-id]');

        if(updateListItems.length == 0) {
            ElementHelper.bindListWithShowMore(this.containerElement);
            ElementHelper.bindListItemsWithHref(this.containerElement);
            ElementHelper.reformatCardContentHeight(this.containerElement);
        }

        updateListItems.each((index, element) => {  
            var updateListElement = $(element);

            let pageNumber = 1;

            let updateId = updateListElement.data('update-id') ?? '';
            if (updateId == undefined) {
                updateId = '';
            }

            let displayType = updateListElement.data('display-type');
            if (displayType == undefined) {
                displayType = '';
            }

            let active = updateListElement.data('active');
            if (active == undefined) {
                active = '';
            }
                    
            let maxNumber = updateListElement.data('max-number');
            if (maxNumber == undefined) {
                maxNumber = '';
            }
            
            let showMoreText= updateListElement.data('show-more-text');
            if (showMoreText == undefined) {
                showMoreText = '';
            }

            let hideLinkText = updateListElement.data('hide-link-text');
            if (hideLinkText == undefined) {
                hideLinkText = '';
            }

            let contentAlign= updateListElement.data('content-align');
            if (contentAlign == undefined) {
                contentAlign = '';
            }

            let blockId = updateListElement.data('block-id');
            if (blockId == undefined) {
                blockId = '';
            }

            let type = updateListElement.data('type');
            if (type == undefined) {
                type = '';
            }

            if (search == undefined) {
                search = '';
            }

            updateListElement.html('<div class="btn-spinner"></div>');

            $.post(`/update/updateslist`,
            {
                'pageNumber' : pageNumber,
                'updateId' : updateId,
                'displayType': displayType,
                'maxNumber' : maxNumber,
                'active' : active,
                'search' : search,
                'showMoreText' : showMoreText,
                'hideLinkText' : hideLinkText,
                'contentAlign' : contentAlign,
                'blockId' : blockId,
                'simpleFilters' : simpleFilters,
                'multipleFilters' : multipleFilters,
                'type' : type,
                "__RequestVerificationToken": (window as any).getToken()
            },
            function(data){
                updateListElement.html(data.view);

                Swiper.use([Navigation, Pagination, Autoplay]);

                updateListElement.find('.swiper-spotlight').each((index, element) => {

                    var parsedSwiperElement = $(element);
                    var amountOfItems = +parsedSwiperElement.data('amount-of-items');
                    const spotlightSwiper = new Swiper(element,
                        {
                            // Optional parameters
                            direction: 'horizontal',
                            loop: true,
                            slidesPerView: 'auto',
                            spaceBetween: 0,
                            breakpoints: {
                                0: {
                                    centeredSlides: true,
                                },  
                                576: {
                                    centeredSlides: false,
                                },
                                992: {
                                    loop: amountOfItems >= 3 ? true : false,
                                    
                                  },
                            },

                            pagination: {
                                el: amountOfItems >= 3 ? updateListElement.find('.swiper-pagination')[0] : undefined,
                            },

                            navigation: {
                                nextEl: updateListElement.find('.swiper-button-next')[0],
                                prevEl: updateListElement.find('.swiper-button-prev')[0],
                                disabledClass: amountOfItems > 3 || amountOfItems < 3 ? 'disabled_swiper_button' : undefined
                            },
                        });
                });

                self.filtersManager.setFiltersCount(+data.totalNumberOfItems, data.labelFilters);

                let showMoreBtn = updateListElement.find('#btn-show-more');

                ElementHelper.bindListWithShowMore(updateListElement);
                ElementHelper.bindListItemsWithHref(updateListElement);
                ElementHelper.reformatCardContentHeight(updateListElement);

                if (<boolean>(data.hasMorePages) == false) {
                    
                    showMoreBtn.hide();
                }
                else {
                    showMoreBtn.click((e) => {
                        showMoreBtn.find('.btn-spinner').removeClass('d-none');
                        e.preventDefault();

                        pageNumber += 1;

                        $.post(`/update/updateslist`,
                        {
                            'pageNumber' : pageNumber,
                            'updateId' : updateId,
                            'maxNumber' : maxNumber,
                            'displayType': displayType,
                            'active' : active,
                            'search' : search,
                            'showMoreText' : showMoreText,
                            'hideLinkText' : hideLinkText,
                            'blockId' : blockId,
                            'simpleFilters' : simpleFilters,
                            'multipleFilters' : multipleFilters,
                            'type' : type,
                            "__RequestVerificationToken": (window as any).getToken()
                        },
                        function(data){
                            showMoreBtn.find('.btn-spinner').addClass('d-none');

                            $(data.view).insertAfter(updateListElement.find('.row').last());

                            ElementHelper.bindListWithShowMore(updateListElement);
                            ElementHelper.bindListItemsWithHref(updateListElement);
                            ElementHelper.reformatCardContentHeight(updateListElement);
                            
                            if (<boolean>(data.hasMorePages) == false) {
                                showMoreBtn.hide();
                            }
                            else {
                                var showMoreText = <string>(data.showMoreText);
                                if(showMoreText.length >= 1) {
                                    showMoreBtn.find('#btn-show-more-text').text(showMoreText);
                                }
                            }
                        });
                    });
                }
            });
        })  
    }
}